var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSystemUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 7.00054C10.9998 7.55282 10.5521 8.00054 9.99982 8.00054C9.44753 8.00054 8.99982 7.55282 8.99982 7.00054C8.99982 6.44825 9.44753 6.00054 9.99982 6.00054C10.5521 6.00054 10.9998 6.44825 10.9998 7.00054Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 9.75054C10.414 9.75054 10.7498 10.0863 10.7498 10.5005V15.5005C10.7498 15.9148 10.414 16.2505 9.99982 16.2505C9.5856 16.2505 9.24982 15.9148 9.24982 15.5005V10.5005C9.24982 10.0863 9.5856 9.75054 9.99982 9.75054Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2702 1.99317C11.1782 0.395509 8.8214 0.395502 7.72943 1.99317L7.29751 2.62512C4.59147 6.58433 2.2665 10.791 0.353774 15.1886L0.263559 15.396C-0.410496 16.9458 0.607868 18.7055 2.28741 18.8932C7.41304 19.4661 12.5865 19.4661 17.7122 18.8932C19.3917 18.7055 20.4101 16.9458 19.736 15.396L19.6458 15.1886C17.7331 10.7909 15.4081 6.58434 12.7021 2.62512L12.2702 1.99317ZM8.96781 2.83958C9.46416 2.11337 10.5354 2.11337 11.0318 2.83958L11.4637 3.47153C14.1163 7.35255 16.3953 11.4761 18.2703 15.7869L18.3605 15.9943C18.6319 16.6184 18.2219 17.3269 17.5456 17.4025C12.5307 17.963 7.46892 17.963 2.45402 17.4025C1.77773 17.3269 1.36767 16.6184 1.63908 15.9943L1.7293 15.7869C3.60425 11.4761 5.88329 7.35254 8.53589 3.47152L8.96781 2.83958Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUpdate);
export default __webpack_public_path__ + "static/media/System_update.ac95555982a9bde95b06057f19651c24.svg";
export { ForwardRef as ReactComponent };